module.exports = __webpack_public_path__ + "static/media/fortlev_solar_vetor_2.0fade0b6.svg";